export default {
  drawer: null,
  color: 'success',
  image: 'https://source.unsplash.com/random',
  selectedMenu:null
}
